/**
 * Employee selection section component
 * Handles employee selection UI
 */

import React from "react";
import { UserSelect } from "@/components/shared/UserSelect";
import type { GrantAccessEmployeeSectionProps } from "@/lib/types/grant-access";
import { formatUserName } from "@/lib/types/grant-access";

export function GrantAccessEmployeeSection({
  userId,
  onUserSelect,
  error,
  preSelectedUser,
}: GrantAccessEmployeeSectionProps) {
  return (
    <div>
      <label className="block text-sm font-medium mb-1">Employee</label>
      {preSelectedUser ? (
        <div className="flex items-center justify-between rounded border px-3 py-2 text-sm bg-muted/30">
          <span className="truncate">{formatUserName(preSelectedUser)}</span>
          <span className="text-xs text-muted-foreground">pre-selected</span>
        </div>
      ) : (
        <>
          <UserSelect
            currentUserId={userId}
            onUserSelect={async (id) => {
              onUserSelect(id);
            }}
            showAllUsers={true}
          />
          {error && <div className="text-xs text-red-600 mt-1 dark:text-red-400">{error}</div>}
          <p className="text-xs text-muted-foreground mt-1">
            Choose the employee to grant client access to.
          </p>
        </>
      )}
    </div>
  );
}
